var req = require("!!/app/node_modules/pug-loader/index.js??ref--13-1!/app/src/linagora.esn.controlcenter/app/general/subheader/subheader.pug");
module.exports = (req['default'] || req).apply(req, [])